import { updateLoadingEffect } from './updateLoadingEffect';

interface TipsportCourses {
  home_win: string;
  away_win: string;
  draw_course: string;
  draw: string;
}

/**
 * Funkce pro aktualizaci kurzů pro Tipsport sázky ve vybraném zápase.
 * Pokud jsou k dispozici kurzové sázky, jejich hodnoty se aktualizují na stránce.
 * Pokud status zápasu je 'fin' (zapas ukončen), obalovací element pro sázky je skryt.
 *
 * @param matchElement - HTMLElement zápasu, který má být aktualizován.
 * @param matchStatus - Stav zápasu.
 * @param tipsportCourses - Kurzy pro sázky na zápas.
 */
export const updateMatchBetCourses = (
  matchElement: HTMLElement,
  matchStatus: string,
  tipsportCourses: TipsportCourses
) => {
  const matchBetWrapper = matchElement.querySelector<HTMLElement>(
    '[data-match-overview-match-bet]'
  );

  if (!tipsportCourses || !matchBetWrapper) return;

  const betSport = matchElement.getAttribute('data-match-sport');

  if (tipsportCourses) {
    const homeWinCourse = matchBetWrapper.querySelector<HTMLElement>(
      '[data-match-home-win-course] span'
    );
    const drawCourse = matchBetWrapper.querySelector<HTMLElement>('[data-match-draw-course] span');
    const awayWinCourse = matchBetWrapper.querySelector<HTMLElement>(
      '[data-match-away-win-course] span'
    );

    if (homeWinCourse && homeWinCourse.textContent !== tipsportCourses.home_win) {
      homeWinCourse.textContent = tipsportCourses.home_win;
      updateLoadingEffect(homeWinCourse);
    }
    if (
      drawCourse &&
      drawCourse.textContent !== tipsportCourses.draw_course &&
      betSport !== 'ten'
    ) {
      drawCourse.textContent = tipsportCourses.draw;
      updateLoadingEffect(drawCourse);
    }
    if (awayWinCourse && awayWinCourse.textContent !== tipsportCourses.away_win) {
      awayWinCourse.textContent = tipsportCourses.away_win;
      updateLoadingEffect(awayWinCourse);
    }
  }

  if (['fin', 'retired'].includes(matchStatus)) {
    matchBetWrapper.textContent = '';
    matchBetWrapper.style.display = 'none';
  }
};
